import numeral from "numeral";
//import { useAppSelector } from "store/hooks";
import { useProject } from "utils/hooks/useProject";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";


const ColdResults: React.FC = () => {
    const { t } = useTranslation();
    const { isThermor } = useSalesNetwork();
    //const projectStore = useAppSelector((state) => state.project);
    const { getValue } = useProject();
    const results_SurfaceRAF = getValue("results.E1[0].SurfaceRAF");
    const results_ColdMaxPowerTransmitters = getValue("results.E1[0].ColdMaxPowerTransmitters");

    return (
        <>
            <group data-direction="column" data-length="autofit" data-justify="start"
                {...(isThermor ? {"data-border-color": "main-color-custom-border", "data-space": "20", "data-space-bottom": "0"} : {  })}
                >
                <text
                    data-weight="600"
                    data-text-size="22"
                    data-ellipsis=""
                    data-space="5"
                >
                    {t("ESTIMATED_COLD_BALANCE")}
                </text>

                <group data-align="center" data-gap="5" data-space="5"><text>{t("TOTAL_RAF_SURFACE")} :</text><text data-weight="600" data-text-size="large">{numeral(results_SurfaceRAF).format('0,0')}&nbsp;m2</text></group>
                <group data-align="center" data-gap="5" data-space="5"><text>{t("MAX_EMITTER_POWER")} :</text><text data-weight="600" data-text-size="large">{numeral(results_ColdMaxPowerTransmitters).format('0,0')}&nbsp;W</text></group>
            </group>
        </>
    )
}

export default ColdResults;